<template>
  <div>{{result}}</div>
</template>
<script>
import store from './dictionaryStore'
export default {
  name: 'ZkDictionaryTransform',
  props: ['type', 'value'],
  data () {
    return {
      result: ''
    }
  },
  mounted () {
    store.getNameByTypeAndValue(this.type, this.value).then(data => {
      this.result = data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/dictionaryTransform/src/main.vue